import { useEffect, useState } from "react";
import SidebarManager from "../../components/SidebarManager.js";
import Header from "../../components/Header.js";
import NumCard from "../../components/NumCard.js";
import CreateCompanyProfile from "../../components/CreateCompanyProfile.js";
import StatsCards from "../../components/StatsCards.js";
import { getDahboardStats } from "../../services/companyService.js";
import { useAuth } from "../../context/AuthContext.js";

function CompanyProfile() {
  const { user } = useAuth();
  const [statistitcs, setStatistitcs] = useState([
    {
      label: "Total Forms",
      value: 0,
      color: "text-indigo-500",
      border: "border-indigo-300",
    },
    {
      label: "Approved Forms",
      value: 0,
      color: "text-green-600",
      border: "border-green-300",
    },
    {
      label: "Pending Forms",
      value: 0,
      color: "text-yellow-500",
      border: "border-yellow-300",
    },
    {
      label: "Rejected Forms",
      value: 0,
      color: "text-red-500",
      border: "border-red-300",
    },
  ]);

  // Replace this with your real API endpoint
  const fetchStats = async () => {
    try {
      const response = await fetch("/api/dashboard-stats");
      const data = await response.json();
      //setStats(data);
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  const fetchDashboard = async () => {
    try {
      const response = await getDahboardStats(user);
      setStatistitcs([
        {
          label: "Total Forms",
          value: response.totalForms,
          color: "text-indigo-500",
          border: "border-indigo-300",
        },
        {
          label: "Approved Forms",
          value: response.approvedForms,
          color: "text-green-600",
          border: "border-green-300",
        },
        {
          label: "Pending Forms",
          value: response.pendingForms,
          color: "text-yellow-500",
          border: "border-yellow-300",
        },
        {
          label: "Rejected Forms",
          value: response.rejectedForms,
          color: "text-red-500",
          border: "border-red-300",
        },
      ]);
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  useEffect(() => {
    // fetchStats();
    fetchDashboard();
  }, []);

  return (
    <div className="py-8 px-[5rem] bg-[#fbfbfb] w-screen mx-auto">
      <Header title="Company Profile" />

      {/* Stats Cards */}

      <div className=" mb-4">
        <StatsCards stats={statistitcs} className="grid grid-cols-4 gap-4" />
      </div>
      {/* Create Company Profile Form */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Create Company Profile</h2>
        <p className="text-sm mb-4 text-gray-500">
          Total: {statistitcs[0].value} Numbers
        </p>
        <CreateCompanyProfile />
      </div>
    </div>
  );
}

export default CompanyProfile;
